import { EventBus } from "./../../event_bus.js";
export default {
  methods: {
    secondsToHms: function(d,section) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
      var hDisplay = h > 0 ? this.numberWithCommas(h) + "h "  : "";
      var mDisplay = m > 0 ? this.numberWithCommas(m) + "m " : "";
      var sDisplay = s > 0 ? 'and ' + s + "s": "";
      if (section) {
        //return this.numberWithCommas(hDisplay + mDisplay);
        return hDisplay + mDisplay;
      } else {
       return hDisplay + mDisplay + sDisplay;
      }
    },
    lessonDurationDigitalTime: function (d, section) {
      if (d == 0) {
        return '-'
      }
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
      var hDisplay = h > 0 ? h + ":" : "";
      var mDisplay = m > 0 ? (m < 10 ? m = "0" + m : m ) + ":" : "00";
      mDisplay < 10 ? mDisplay = "0" + mDisplay : mDisplay

      var sDisplay = s > 0 ?  s + ""  : "00";
      if (section) {
        return hDisplay + mDisplay ;
      } else {
       return hDisplay + mDisplay + sDisplay;
      }
    },
    removeModalLanguage: function(language) {
      //remove language from module_languages

      this.languageRequestModule(language, false);
    },
    addModalLanguage: function(language) {
      this.languageRequestModule(language, true);
    },
    /*
    * this function will do remove or add language job based on given parameters
    */
    languageRequestModule: function(language, add_to_module) {
      let language_key = language.key;
      let mod = this.current_module;
      var params = {
        id: mod.id,
        language: language_key,
        full: true
      };
      var request_call = "";
      if (add_to_module) {
        request_call = "addLanguageToModule";
      } else {
        request_call = "removeLanguageFromModule";
      }
      this.$store.dispatch(request_call, params).then(res => {
        this.current_module = res.data.module;
        //let index = this.module_list.findIndex(obj =>obj.id == module.module.id)
        console.log(this.course_data.modules);
        if (this.course_data.modules) {
          let index_ = this.course_data.modules.findIndex(
            obj => obj.id === this.current_module.id
          );
          let order = this.course_data.modules[index_].order;
          res.data.module.order = order;
          this.course_data.modules[index_] = res.data.module;
          EventBus.$emit("update_module", this.current_module);
        } else {
          EventBus.$emit("update_module", this.current_module);
        }

        //if we remove language from module, add it to dropdown for now
        if (!add_to_module) {
          this.module_languages = this.module_languages.filter(elem => {
            return elem.value != language.value;
          });
          EventBus.$emit("add_language", language);
        } else {
          EventBus.$emit("addLanguageModuleTrigger", language);
        }
      });
    },
    numberWithCommas: function(x) {
    //    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        return x.toLocaleString("en-US");
    }
  }
};




// WEBPACK FOOTER //
// ./src/components/sme/MixinSME.js